import { IconTile } from './IconTile';
import type { IconTileGroupData } from './types';

const IconTileGroup = ({ data }: { data: IconTileGroupData }) => {
  const { heading, items = [] } = data;

  if (items.length === 0) {
    return null;
  }

  return (
    <div className='mt-3'>
      {heading && <p className='text-lg font-semibold mb-4'>{heading}</p>}

      {/* <div className='flex gap-2 sm:justify-between'>
        {items.map((item) => (
          <IconTile
            key={item.id}
            data={item}
          />
        ))}
      </div> */}
      <div
        className={`grid gap-2 ${
          items.length === 2 ? 'grid-cols-2' : items.length === 3 ? 'grid-cols-3' : 'grid-cols-1'
        }`}
      >
        {items.map((item) => (
          <IconTile
            key={item.id}
            data={item}
          />
        ))}
      </div>
    </div>
  );
};

export default IconTileGroup;
